import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime.js';
import { Button, Flex } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/redux/index.js';
import { accountIdentifierEmailSelector, isLoadingSelector, updateEmailError, updateEmailErrorMessage, verifyAccountExistsThunk, } from '../accountIdentifierSlice.js';
import { validateEmail } from '../../../../../helpers/validateEmail.js';
import { EmailAddressInput } from './EmailAddressInput.js';
import { sendGlobalTrackingThunk } from '../../../../../core/thunks.js';
import { trackButtonClick, trackFormFieldError } from '../../../../../tracking/index.js';
import { trackingTwoStepLoginRegistrationStateSelector } from '../../../twoStepLoginRegistrationSlice.js';
export const EmailInputWithButton = () => {
    const { t } = useTranslation();
    const { value } = useAppSelector(accountIdentifierEmailSelector);
    const isLoading = useAppSelector(isLoadingSelector);
    const dispatch = useAppDispatch();
    const componentState = useAppSelector(trackingTwoStepLoginRegistrationStateSelector);
    const verifyButtonClick = () => {
        dispatch(sendGlobalTrackingThunk(trackButtonClick, {
            componentState,
            uniqueName: 'continueWithEmail',
        }));
        const isValidEmail = validateEmail(value);
        if (!isValidEmail) {
            dispatch(updateEmailError(true));
            dispatch(updateEmailErrorMessage(t('loginregistration.email.validation.error')));
            dispatch(sendGlobalTrackingThunk(trackFormFieldError, {
                formFieldErrors: 'emailAddressNotValid',
                componentState,
            }));
        }
        if (isValidEmail) {
            dispatch(verifyAccountExistsThunk());
        }
    };
    return (_jsxs(Flex, { flxDirection: 'column', children: [_jsx(EmailAddressInput, {}), _jsx(Button, { "data-testid": "rlac-primary-continue-btn", variant: "primary", a11yLabel: "Continue button", type: "submit", onClick: verifyButtonClick, isLoading: isLoading, isFullWidth: true, marginTop: 'spaceL', size: ['medium'], children: t('loginregistration.twoStepLoginRegistration.button.continue') })] }));
};
//# sourceMappingURL=EmailInputWithButton.js.map